import CookieConsentAcceptButton from "src/Candidate/atoms/CookieConsentAcceptButton";
import CookieConsentDeclineButton from "src/Candidate/atoms/CookieConsentDeclineButton";
import CookieConsentTitle from "src/Candidate/atoms/CookieConsentTitle";
import CookieConsentDescription from "src/Candidate/atoms/CookieConsentDescription";
import styles from "./CookieConsent.module.css";

export default function CookieConsent(): JSX.Element {
  return (
    <div className={styles.modal}>
      <div className={styles.inner}>
        <div className={styles.header}>
          <CookieConsentTitle />
          <CookieConsentDescription />
        </div>
        <div className={styles.actions}>
          <CookieConsentAcceptButton />
          <CookieConsentDeclineButton />
        </div>
      </div>
    </div>
  );
}
